'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shellFg = shellFg;
exports.shellBg = shellBg;
exports.shellStyle = shellStyle;
exports.shellReset = shellReset;
var shellColor = exports.shellColor = {
  reset: '\x1b[0m',
  bright: '\x1b[1m',
  dim: '\x1b[2m',
  underscore: '\x1b[4m',
  blink: '\x1b[5m',
  reverse: '\x1b[7m',
  hidden: '\x1b[8m',
  fg: {
    black: '\x1b[30m',
    red: '\x1b[31m',
    green: '\x1b[32m',
    yellow: '\x1b[33m',
    blue: '\x1b[34m',
    magenta: '\x1b[35m',
    cyan: '\x1b[36m',
    white: '\x1b[37m',
    crimson: '\x1b[38m'
  },
  bg: {
    black: '\x1b[40m',
    red: '\x1b[41m',
    green: '\x1b[42m',
    yellow: '\x1b[43m',
    blue: '\x1b[44m',
    magenta: '\x1b[45m',
    cyan: '\x1b[46m',
    white: '\x1b[47m',
    crimson: '\x1b[48m'
  }
};

function shellFg(name) {
  return __SERVER__ ? shellColor.fg[name] || '' : '';
}

function shellBg(name) {
  return __SERVER__ ? shellColor.bg[name] || '' : '';
}

function shellStyle(name) {
  return __SERVER__ ? shellColor[name] || '' : '';
}

function shellReset() {
  return __SERVER__ ? shellColor.reset : '';
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/console-color.js
// module id = 867
// module chunks = 1